<template>
  <div class="options">
    <template v-if="config.optionsMenthods === 'select'">
      <div class="pick-l" v-if="config.optionsConfig" :key="optionKey">
        <template v-if="config.optionsConfig && config.optionsConfig.type === 'pick'">
          <template v-for="it in config.optionsConfig.config">
            <el-radio v-model="value" @change="changeValue"
              v-if="isAppenBtn(it, colIdx, rowIdx)" :label="it.name" :key="it.i" />
          </template>
        </template>
        <div v-else class="xing-lll">
          <template v-for="it in config.optionsConfig.config">
            <i :key="it.i" v-if="isAppenBtn(it.name, colIdx, rowIdx)"
              :class="['iconfont icon-xingxing xing', value >= it.name ? 'xing-active' : '']"
              @click.stop="changeValue(it)" />
          </template>
        </div>
      </div>
      <template v-else>
        未设置
      </template>
    </template>
    <template v-else-if="config.optionsMenthods === 'radio'">
      <el-radio @change="changeValue" :key="optionKey" :label="label"
        v-model="value">
        <span></span>
      </el-radio>
    </template>
    <template v-else-if="config.optionsMenthods === 'checkbox'">
      <el-checkbox :key="optionKey" v-model="value" @change="changeValue"></el-checkbox>
    </template>
    <template v-else-if="config.optionsMenthods === 'input'">
      <template
        v-if="config.singleConfig && config.singleConfig.info && config.singleConfig.info.inputType === 'number'">
        <el-input-number :key="optionKey" v-model="value" label="请输入填写内容" @change="changeValue"></el-input-number>
      </template>
      <template v-else>
        <el-input placeholder="请输入填写内容" :key="optionKey" v-model="value" @change="changeValue"></el-input>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'optionsComp',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    optionKey: {
      type: [Number, String],
      default: 0
    },
    label: {
      type: [String, Number],
      default: ''
    },
    isAppenBtn: {
      type: Function,
      default: () => true
    },
    val: {
      type: [String, Number, Boolean],
      default: ''
    },
    isAll: {
      type: Boolean,
      default: false
    },
    colIdx: {
      type: Number,
    },
    rowIdx: {
      type: Number,
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      value: ''
    }
  },
  mounted() {
    this.value = this.val
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    val: {
      handler(val) {
        this.value = val
      },
      deep: true
    }
  },
  // 组件方法
  methods: {
    changeValue(val) {
      this.$emit('change', { value: val, type: this.isAll ? 'all' : 'options' })
    },
    async pendingRes(event) {
      if (event.target.tagName === "INPUT") {
        let id = event.target.value
        if (this.value != id) {
          // TODO
        } else {
          this.value = ''
          this.changeValue(this.value)
        }
    }
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-input {
  height: 32px;
  line-height: 32px;

  .el-input__inner {
    line-height: 32px;
    height: 100%;
  }
}

.options {
  overflow: hidden;
}

.xing-lll {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
}

.xing {
  margin-right: 10px;
  color: #D8D8D8;
  font-size: 16px;
}

.xing-active {
  color: #FFD12F;
}

.pick-l {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  ::v-deep .el-radio {
    margin-right: 8px;
  }
}

.pick-l-l {
  display: flex;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
}

.pick-l-l-x {
  background-color: #FFFFFF;
  border: 1px solid #DDE0E6;
  width: 14px;
  min-width: 14px;
  height: 14px;
  border-radius: 50%;
  box-sizing: border-box;
}

.pick-l-l-n {
  color: #666666;
  font-weight: 400;
  font-size: 12px;
  margin-left: 6px;
}

.pick-l-active {
  .pick-l-l-x {
    border: 5px solid #4E86FF;
  }
}

::v-deep .radio-options {
  .el-radio__label {
    padding-left: 0;
  }
}

::v-deep .el-input-number {
  width: 100%;
}
</style>